module.exports = __webpack_public_path__ + "static/media/login.c0503999.jpg";